/* eslint-disable import/prefer-default-export */
export const pushRoute = url => window.location.assign(url);
